var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1875 21.5C17.8153 21.5 15.4576 20.9167 13.1146 19.75C10.7715 18.5833 8.66667 17.0667 6.8 15.2C4.93333 13.3333 3.41667 11.2285 2.25 8.88542C1.08333 6.54236 0.5 4.18472 0.5 1.8125C0.5 1.44306 0.626389 1.13194 0.879167 0.879167C1.13194 0.626389 1.44306 0.5 1.8125 0.5H5.89583C6.16806 0.5 6.40625 0.592361 6.61042 0.777083C6.81458 0.961805 6.94583 1.20972 7.00417 1.52083L7.79167 5.19583C7.83056 5.46806 7.82569 5.71597 7.77708 5.93958C7.72847 6.16319 7.62639 6.35278 7.47083 6.50833L4.55417 9.45417C5.64306 11.2625 6.86319 12.8375 8.21458 14.1792C9.56597 15.5208 11.0972 16.6583 12.8083 17.5917L15.5792 14.7333C15.7736 14.5194 15.9972 14.3687 16.25 14.2812C16.5028 14.1937 16.7556 14.1792 17.0083 14.2375L20.4792 14.9958C20.7708 15.0542 21.0139 15.2 21.2083 15.4333C21.4028 15.6667 21.5 15.9389 21.5 16.25V20.1875C21.5 20.5569 21.3736 20.8681 21.1208 21.1208C20.8681 21.3736 20.5569 21.5 20.1875 21.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCell);
export default __webpack_public_path__ + "static/media/cell.bfbe9139175f4e635a23fd2008df6c48.svg";
export { ForwardRef as ReactComponent };